var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import { ReactViewController } from '@veeam/core';
import { TabList } from "../../../TabList";
var WizardTabsViewController = /** @class */ (function (_super) {
    __extends(WizardTabsViewController, _super);
    function WizardTabsViewController() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.tabs = new Map();
        return _this;
    }
    WizardTabsViewController.prototype.createElement = function (navigation) {
        var _this = this;
        return (React.createElement(TabList, { width: this.width, items: navigation.map(function (_a) {
                var id = _a.id, active = _a.active, disabled = _a.disabled;
                return ({
                    onClick: function () {
                        if (!disabled) {
                            _this.listener && _this.listener.didSelectStepById(id);
                        }
                    },
                    active: active,
                    disabled: disabled,
                    render: function () { return _this.getTabElement(id); }
                });
            }) }));
    };
    WizardTabsViewController.prototype.present = function (state) {
        this.setState(state);
    };
    WizardTabsViewController.prototype.getTabElement = function (id) {
        var tab = this.tabs.get(id);
        if (!tab) {
            return null;
        }
        return tab.render() || null;
    };
    WizardTabsViewController.prototype.registerTab = function (id, viewController) {
        this.tabs.set(id, viewController);
    };
    return WizardTabsViewController;
}(ReactViewController));
export { WizardTabsViewController };
//# sourceMappingURL=WizardTabsViewController.js.map